const initialState = {
  isLoggedIn: localStorage.getItem('isLoggedIn') === 'true',
  token: localStorage.getItem('token') || "",
  user: JSON.parse(localStorage.getItem('user')) || null,
  showAuth: false
}

const user = (state = initialState, action) => {
  switch (action.type) {
    case 'SIGNIN':
    case 'SIGNUP':
      return { 
        ...state, 
        isLoggedIn: true, 
        token: action.data.token, 
        user: action.data.user,
        showAuth: false 
      }
    case 'LOGOUT':
      return { 
        ...state, 
        isLoggedIn: false, 
        token: "", 
        user: null 
      }
    case 'SHOW_AUTH':
      return { ...state, showAuth: true }
    case 'CLOSE_AUTH':
      return { ...state, showAuth: false }
    default:
      return state
  }
}

export default user
